<mat-form-field class="suggest-text width-100" floatLabel="never">
  <input type="text" placeholder="Auto Suggest Text Response" aria-label="Auto Suggest Text Response" matInput [formControl]="suggestedText"
    [matAutocomplete]="auto" (change)="onInput($event)">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="optionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{option.text}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>